import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { LoginContext } from "../../context/loginContext";
import { Button, Card, Input, Spinner } from "../ui";

const Login = () => {
    const { action } = useContext(LoginContext);
    const history = useHistory();

    const [user, setUser] = useState({ username: "", password: "" });
    const [validationError, setValidationError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleUpdate = (event) => {
        const { name, value } = event.target;
        setUser((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!user.username && !user.password) {
            setValidationError("Please enter a username and password.");
            return;
        }
        if (!user.password) {
            setValidationError("Please enter a password.");
            return;
        }
        if (!user.username) {
            setValidationError("Please enter a username.");
            return;
        }

        setSubmitting(true);
        try {
            const response = await action.signIn(user);
            if (response) {
                setValidationError("");
                history.push("/");
            } else {
                setValidationError("The username or password you have entered does not match.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-ink-50 flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-sm">
                <div className="mb-8 flex flex-col items-center">
                    <img
                        src="https://cdn.prod.website-files.com/63ffce129be7494e7cb1c6a2/65e79afd60fde8ed10fe2853_new%20logo.png"
                        alt="Summit Doors"
                        className="mb-3 h-12 w-auto max-w-[10rem] object-contain"
                    />
                    <h1 className="text-2xl font-semibold tracking-tight text-ink-900">
                        Summit Doors
                    </h1>
                    <p className="mt-1 text-sm text-ink-500">Sign in to access your portal</p>
                </div>

                <Card className="space-y-4">
                    {validationError && (
                        <div
                            role="alert"
                            className="rounded-lg border border-danger-200 bg-danger-50 px-3 py-2 text-sm text-danger-700"
                        >
                            {validationError}
                        </div>
                    )}
                    <form className="space-y-4" onSubmit={handleSubmit}>
                        <Input
                            id="login-username"
                            label="Username"
                            type="text"
                            name="username"
                            size="sm"
                            value={user.username}
                            onChange={handleUpdate}
                            autoComplete="username"
                            placeholder="Enter your username"
                        />
                        <Input
                            id="login-password"
                            label="Password"
                            type="password"
                            name="password"
                            size="sm"
                            value={user.password}
                            onChange={handleUpdate}
                            autoComplete="current-password"
                            placeholder="Enter your password"
                        />
                        <Button
                            type="submit"
                            className="w-full"
                            size="lg"
                            disabled={submitting}
                            leadingIcon={
                                submitting ? (
                                    <Spinner
                                        size="sm"
                                        className="!border-white/40 !border-t-white"
                                    />
                                ) : null
                            }
                        >
                            {submitting ? "Signing in..." : "Sign in"}
                        </Button>
                    </form>
                </Card>
            </div>
        </div>
    );
};

export default Login;
